module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("4:"), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Statue of a Young Napoleon")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("t the age of nine, Napoleon was sent from his home in Corsica to Brienne in the Champagne region of France to attend one of the twelve military schools which acted as preparatory schools for the main Military Academy in Paris. The school was run by Benedictine monks, who received sixty "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pensionnaires")]), _vm._v(" from moneyed aristocracy and sixty from the poorer nobility, of which Napoleon was one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lessons taught here were French (a relatively new language to Napoleon), Latin, Mathematics, History, Geography, Technical Drawing, Music, Fencing and Military Fortifications. Throughout his five years at the school, Napoleon was entirely cut off from his family and he had to endure severe discipline and an austere life in the unheated cells the students lived in.")]), _vm._v(" "), _c('div', {
    staticClass: "img_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_vm._v("This statue of a young Napoleon is at Brienne Town Hall.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_vm._v("Napoleon at his studies.")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0009-01.jpg"
    }
  })]), _c('p', {
    staticClass: "fcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The École Militaire at Brienne.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Napoleon was singled out by the other cadets for his poor social skills, ardent Corsican nationalism and dreadful French with a thick Corsican accent. He was bullied repeatedly. Napoleon became withdrawn and applied himself to his studies as a way of coping. There are a number of anecdotes regarding the young Napoleon leading his school friends in a snowball fight, as if he was already a general. However, given his poor standing in the school with few friends, it is more likely that many of these stories emerged later, to colour what was a difficult period for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He excelled particularly at Mathematics, and having passed his exams for the Artillery, Napoleon left Brienne on 30 October 1784 for the Military Academy in Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Napoleon only visited Brienne twice later in his life; he passed through on his way to Milan in 1805 when he became King of Italy and returned again in 1814, when he fought two battles in the area while staying at Château Brienne. At the Battle of Brienne, Napoleon was nearly captured by Russian Cossacks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Military School closed in 1790 having been partly destroyed in the Revolution. Napoleon granted 12,000 francs for its repair, but it never happened. In his will Napoleon also bequeathed 1 million francs to the town.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He is recorded as having said:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("‘As regards my thinking, it is not Corsica but Brienne that is my native land, because it was there that I formulated my first opinions of mankind.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f80961b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter_04.vue
// module id = 84
// module chunks = 0